import React from 'react';
import ReactIframeResizer from 'react-iframe-resizer-super';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  iframe: {
    border: 'none',
  },
}));

const Hackschnitzelrechner = () => { // eslint-disable-line
  const classes = useStyles();
  return (
    <div>
      <ReactIframeResizer
        iframeResizerUrl={false}
        iframeResizerOptions={{
          checkOrigin: false,
        }}
        src={`https://www.power-pellets.de/energieverbrauchsrechner/hackschnitzelrechner.html?utm_source=tool&utm_medium=hack&utm_campaign=integration&page=1&v=${(
          Math.random() * 1000
        ).toFixed(0)}`}
        className={classes.iframe}
      />
    </div>
  );
};

export default Hackschnitzelrechner;
